import React, { useState } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas }     from "@fortawesome/free-solid-svg-icons"
library.add(fas)

import { getRequest } from "@react/helpers/fetch"
import { rememberEntity } from "@react/helpers/entity_filter"

import Header                  from "./components/Header"
import FilterBar               from "./components/FilterBar"
import KpiStrip                from "./components/KpiStrip"
import ProjectsPieChart        from "./components/ProjectsPieChart"
import QuotesPieChart          from "./components/QuotesPieChart"
import MonthlyChart            from "./components/MonthlyChart"
import QuotesIssuedChart       from "./components/QuotesIssuedChart"
import TopClientsChart         from "./components/TopClientsChart"
import TopClientsByQuoteChart  from "./components/TopClientsByQuoteChart"
import ManagersChart           from "./components/ManagersChart"
import MarginDistribution      from "./components/MarginDistribution"

const buildQuery = (filters) => {
  const params = new URLSearchParams()
  if (filters.period_from)       params.set("period_from", filters.period_from)
  if (filters.period_to)         params.set("period_to",   filters.period_to)
  if (filters.partner)           params.set("partner",     filters.partner)
  ;(filters.client_ids       || []).forEach(id => params.append("client_ids[]",       id))
  ;(filters.manager_ids      || []).forEach(id => params.append("manager_ids[]",      id))
  ;(filters.project_statuses || []).forEach(s  => params.append("project_statuses[]", s))
  ;(filters.quote_statuses   || []).forEach(s  => params.append("quote_statuses[]",   s))
  return params.toString()
}

const App = ({ data: initialData, json_url }) => {
  const [data, setData]       = useState(initialData || {})
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState(initialData?.filters || {})

  const refresh = (nextFilters) => {
    setLoading(true)
    const qs = buildQuery(nextFilters || filters)
    getRequest(`${json_url}${qs ? `?${qs}` : ""}`).then(response => {
      if (response && !response.errors) {
        setData(response)
        setFilters(response.filters)
      }
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const handleFiltersChange = (nextFilters) => {
    if (data.partner_filter) rememberEntity(data.partner_filter.param, nextFilters.partner)
    setFilters(nextFilters)
    refresh(nextFilters)
  }

  const { kpis, charts, filter_options, currency, partner_filter } = data

  return (
    <div className="pb-12">
      <Header  />
      <FilterBar
        filters         = {filters}
        filter_options  = {filter_options}
        partner_filter  = {partner_filter}
        loading         = {loading}
        onChange        = {handleFiltersChange}
      />

      <div className="px-7 mt-5">
        <KpiStrip kpis={kpis || {}} />
      </div>

      <div className="px-7 mt-6 grid grid-cols-1 lg:grid-cols-2 gap-5">
        <ProjectsPieChart data={charts?.projects_by_status || []} />
        <QuotesPieChart   data={charts?.quotes_by_status   || []} />
      </div>

      <div className="px-7 mt-5 grid grid-cols-1 lg:grid-cols-2 gap-5">
        <MonthlyChart       data={charts?.monthly_invoiced || []} currency={currency} />
        <QuotesIssuedChart  data={charts?.monthly_quotes   || []} />
      </div>

      <div className="px-7 mt-5 grid grid-cols-1 lg:grid-cols-2 gap-5">
        <TopClientsChart         data={charts?.top_clients          || []} currency={currency} />
        <TopClientsByQuoteChart  data={charts?.top_clients_by_quote || []} />
      </div>

      <div className="px-7 mt-5">
        <ManagersChart data={charts?.managers_breakdown || []} />
      </div>

      <div className="px-7 mt-5">
        <MarginDistribution data={charts?.margin_distribution || []} />
      </div>
    </div>
  )
}

export default App
